import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Chip,
  LinearProgress,
  TableBody,
  TableCell,
  TableFooter,
  TablePagination,
  TableRow,
  Tooltip,
  // Typography,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { getAuthInfo } from "store/slices/auth";
import AppTable from "../Table/AppTable";
import AppUtil from "utilities/AppUtil";
import { fetchSubscriptionHistories } from "store/slices/company";
import TablePaginationActions from "../Table/TablePaginationActions";
import { reduceCancelSubscription } from "store/slices/subscription";
import AppColor from "utilities/AppColor";
import AppConfirmDialog from "components/Dialog/AppConfirmDialog";
import { makeStyles } from "@material-ui/core";
import { getMe } from "store/slices/auth";
import moment from "moment";
import AppConfig from "config/AppConfig";

const headCellsNoAction = [
  {
    id: "packageName",
    numeric: "left",
    disablePadding: false,
    label: "label.packageName",
    sort: false,
  },
  {
    id: "pricing",
    numeric: "left",
    disablePadding: false,
    label: "label.price",
    sort: false,
  },
  {
    id: "recurring",
    numeric: "left",
    disablePadding: false,
    label: "label.recurring",
    sort: false,
  },
  {
    id: "numberClient",
    numeric: "left",
    disablePadding: false,
    label: "label.number_participant",
    sort: false,
  },
  {
    id: "numberWorker",
    numeric: "left",
    disablePadding: false,
    label: "label.number_staff",
    sort: false,
  },
  {
    id: "expiredDate",
    numeric: "left",
    disablePadding: false,
    label: "label.expiredDate",
    sort: false,
  },
  {
    id: "subscriptionStatus",
    numeric: "left",
    disablePadding: false,
    label: "label.status",
    sort: false,
  }
];

const headCellsHaveAction = [
  {
    id: "packageName",
    numeric: "left",
    disablePadding: false,
    label: "label.packageName",
    sort: false,
  },
  {
    id: "pricing",
    numeric: "left",
    disablePadding: false,
    label: "label.price",
    sort: false,
  },
  {
    id: "recurring",
    numeric: "left",
    disablePadding: false,
    label: "label.recurring",
    sort: false,
  },
  {
    id: "numberClient",
    numeric: "left",
    disablePadding: false,
    label: "label.number_participant",
    sort: false,
  },
  {
    id: "numberWorker",
    numeric: "left",
    disablePadding: false,
    label: "label.number_staff",
    sort: false,
  },
  {
    id: "expiredDate",
    numeric: "left",
    disablePadding: false,
    label: "label.expiredDate",
    sort: false,
  },
  {
    id: "subscriptionStatus",
    numeric: "left",
    disablePadding: false,
    label: "label.status",
    sort: false,
  },
  {
    id: "actions",
    numeric: "center",
    disablePadding: false,
    label: "label.actions",
    sort: false,
  },
]

const styles = makeStyles(() => ({
  shortText: {
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
    maxWidth: '376px'
}
}));
const SubscriptionListHistories = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const classes = styles();
  const [data, setData] = useState([]);
  const emptyRows = data.length === 0;
  const [loading, setLoading] = useState(false);
  const [queries, setQueries] = useState({
    page: 1,
    size: 10,
  });
  const [totalElements, setTotalElements] = useState(0);
  const [showModalConfirm, setShowModalConfirm] = useState(false);
  const userInfo = useSelector(getAuthInfo);

  const { companyId, cancelSubscription, companySubscriptionId, companySubcriptionExpiryDate } = userInfo;
  // const [subscriptionExpiredDate, setExpiredDate] = useState('');
  const [isExpired, setIsExpired] = useState(false);
  const [headCells, setHeadCells] = useState([]);


  const _loadData = async ({ page, size }) => {
    const newQueries = {
      data: {
        ...queries,
      },
      companyId: companyId,
    };
    if (page) {
      newQueries["data"].page = page;
    }
    if (size) {
      newQueries["data"].size = size;
    }
    setLoading(true);
    dispatch(fetchSubscriptionHistories(newQueries)).then(({ payload }) => {
      setLoading(false);
      if (payload) {
        setQueries(newQueries.data);
        setTotalElements(payload.totalElements);
        setData(payload.content);
      }
    });
    // const result = await dispatch(fetchSubscriptionHistories(newQueries));
    // if (result.payload) {
    //   const _list = result.payload.filter(item => item.id === companySubscriptionId);
    //   setData(_list);
    // }
  };

  const handleChangePage = (event, newPage) => {
    _loadData({ ...queries, page: newPage + 1 });
    AppUtil.scrollToTopById("main-panel");
  };

  const handleChangeRowsPerPage = (event) => {
    _loadData({
      ...queries,
      page: 1,
      size: parseInt(event.target.value),
    });
    AppUtil.scrollToTopById("main-panel");
  };
  const handleCancelSubscription = async () => {
    setShowModalConfirm(false);
    await dispatch(reduceCancelSubscription());
    await dispatch(getMe());
  };

  useEffect(() => {
    _loadData({ ...queries });
  }, []);

  useEffect(() => {
    if (cancelSubscription) {
      setHeadCells(headCellsNoAction)
    } else {
      setHeadCells(headCellsHaveAction);
    }
  }, [cancelSubscription]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (companySubcriptionExpiryDate) {
        const _expiredDate = moment(companySubcriptionExpiryDate);
        const currentDate = moment();
        if (_expiredDate.diff(currentDate) > 0) {
          setIsExpired(false);
        } else {
          setIsExpired(true);
          clearInterval(interval);
          // if (!cancelSubscription) {
          //   window.location.reload();
          // }
        }
        // setExpiredDate(companySubcriptionExpiryDate);
      }
    }, 100); 
  }, [companySubcriptionExpiryDate, cancelSubscription]);

  return (
    <React.Fragment>
      {/* <Typography style={{color: isExpired ? AppColor.red : AppColor.orange}} align="center">
        {isExpired ? `${t('text.expired_date_subscription')}${AppUtil.formatDate(subscriptionExpiredDate, "MM/DD/YYYY HH:mm:ss")}${t('text.expired_date_subscription_2')}`
        : `${t('text.near_expired_date_subscription')}${AppUtil.formatDate(subscriptionExpiredDate, "MM/DD/YYYY HH:mm:ss")} ※`}
        </Typography> */}
      <AppTable
        // onRequestSort={onRequestSort}
        // order={queries.sort === true ? "asc" : "desc"}
        // orderBy={queries.sortField}
        rowCount={data.length}
        headCells={headCells}
      >
        <TableBody>
          {loading && (
            <TableRow>
              <TableCell colSpan={headCells.length} padding="none">
                <LinearProgress />
              </TableCell>
            </TableRow>
          )}
          {data.map((row, index) => (
            <TableRow key={index}>
              <TableCell>{row.packageName && row.packageName.length > 32 ?
                <Tooltip title={row.packageName}><p className={classes.shortText}>{row.packageName}</p></Tooltip>
              : <span>{row.packageName}</span>}</TableCell>
              <TableCell>${row.pricing}</TableCell>
              <TableCell>{row.recurring}</TableCell>
              <TableCell>{row.numberClient}</TableCell>
              <TableCell>{row.numberWorker}</TableCell>
              <TableCell>
                {AppUtil.formatDate(row.expiredDate, AppConfig.DATE_FORMAT.DEFAULT)}
              </TableCell>
              <TableCell>
                {row.subscriptionStatus}
              </TableCell>
              {index == 0 && row.subscriptionId === companySubscriptionId && !cancelSubscription && !isExpired ? <TableCell align="center">
                  <Chip
                    style={{
                      backgroundColor: AppColor.red,
                      color: AppColor.white
                    }}
                    size="small"
                    label={t('button.cancel')}  
                    onClick={() => setShowModalConfirm(true)}
                  />
              </TableCell> : <TableCell></TableCell>}
            </TableRow>
          ))}

          {emptyRows > 0 && (
            <TableRow style={{ height: 53 }}>
              <TableCell colSpan={headCells.length} className="text-center">
                {t("label.no_data")}
              </TableCell>
            </TableRow>
          )}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              colSpan={headCells.length}
              count={totalElements}
              rowsPerPage={queries.size}
              page={queries.page - 1}
              SelectProps={{
                inputProps: { "aria-label": "rows per page" },
                native: true,
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
              labelRowsPerPage={`${t("label.rows_per_page")}:`}
              labelDisplayedRows={({ from, to, count }) =>
                t("label.from_to", {
                  from,
                  to,
                  count: count !== -1 ? count : `${t("text.more_than")} ${to}`,
                })
              }
            />
          </TableRow>
        </TableFooter>
      </AppTable>
      <AppConfirmDialog
        open={showModalConfirm}
        onConfirm={() => handleCancelSubscription()}
        onClose={() => setShowModalConfirm(false)}
        title={t("title.cancel_subscription_plan")}
        content={t("text.cancel_subscription_plan")}
      />
    </React.Fragment>
  );
};

export default SubscriptionListHistories;
